/**
 * useNexoComercial — fetches the SKU → Factura → DIM traceability rows
 * from the `vista_nexo_comercial` view, scoped by embarque_id.
 *
 * RLS is enforced at the view level via security_invoker, so no extra
 * org_id filter is required (defence-in-depth still applies if available).
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { NexoComercialRow } from "@/lib/exportNexoComercial";

export function useNexoComercial(embarqueId: string | null | undefined) {
  return useQuery({
    queryKey: ["nexo-comercial", embarqueId],
    enabled: !!embarqueId,
    queryFn: async (): Promise<NexoComercialRow[]> => {
      const { data, error } = await (supabase as any)
        .from("vista_nexo_comercial")
        .select("*")
        .eq("embarque_id", embarqueId);
      if (error) throw error;
      return (data ?? []) as NexoComercialRow[];
    },
  });
}
